"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveSVGLoaderFuncBudPay = exports.OpenSVGLoaderFuncBudPay = void 0;

// Create SVG Loader Function
var OpenSVGLoaderFuncBudPay = function OpenSVGLoaderFuncBudPay() {
  var svgLoaderDiv = document.createElement("div");
  svgLoaderDiv.setAttribute("id", "budpay-svg-loader-container");
  svgLoaderDiv.setAttribute("style", "position:fixed;top:0;left:0;z-index:99999999999999;border:none;pointer-events:none;width:100%;height:100%;background:rgba(0,0,0,0.65);display:flex;justify-content:center;align-items:center;");
  svgLoaderDiv.innerHTML = "\n            <svg version=\"1.1\" id=\"L9\" width=\"80\" height=\"80\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 0 0\" xml:space=\"preserve\">\n                <path fill=\"#fff\" d=\"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50\">\n                <animateTransform attributeName=\"transform\" attributeType=\"XML\" type=\"rotate\" dur=\"0.7s\" from=\"0 50 50\" to=\"360 50 50\" repeatCount=\"indefinite\"></animateTransform>\n                </path>\n            </svg>\n        ";
  return svgLoaderDiv;
}; // Remove SVG Loader Function


exports.OpenSVGLoaderFuncBudPay = OpenSVGLoaderFuncBudPay;

var RemoveSVGLoaderFuncBudPay = function RemoveSVGLoaderFuncBudPay() {
  if (document.body.contains(document.getElementById('budpay-svg-loader-container'))) {
    document.getElementById('budpay-svg-loader-container').remove();
  }
};

exports.RemoveSVGLoaderFuncBudPay = RemoveSVGLoaderFuncBudPay;